"use client"

import { useState, useEffect, useRef } from "react"
import { Container, Col, Row, Navbar, Nav, Card, ProgressBar, Badge } from "react-bootstrap"
import {
  Mail,
  Phone,
  MapPin,
  Github,
  Linkedin,
  ExternalLink,
  Code,
  Database,
  Globe,
  Server,
  Palette,
  Calendar,
  Award,
  User,
  Briefcase,
  MessageSquare,
  Send,
  Zap,
  Target,
  Cloud,
  Rocket,
  TrendingUp,
} from "lucide-react"
import { Link } from "react-router-dom"
import Particles from "react-tsparticles"
import { loadFull } from "tsparticles"
import "react-multi-carousel/lib/styles.css"
import "bootstrap/dist/css/bootstrap.min.css"
import "../assets/Styles/styleCarousel.css"

import navIcon1 from "../assets/images/facebook.png"
import navIcon2 from "../assets/images/instagram.png"
import navIcon3 from "../assets/images/linkedin.png"
import navIcon4 from "../assets/images/twitter.png"

const particleOptions = {
  background: { color: { value: "#007bff" } },
  particles: {
    number: { value: 50 },
    shape: { type: "circle" },
    opacity: { value: 0.5, random: true },
    size: { value: 3, random: true },
    move: { enable: true, speed: 2, direction: "none" },
    line_linked: { enable: true, distance: 150, color: "#ffffff", opacity: 0.4, width: 1 },
  },
  interactivity: {
    events: {
      onHover: { enable: true, mode: "repulse" },
      onClick: { enable: true, mode: "push" },
    },
  },
}

// Données des expériences professionnelles
const experiencesProfessionnelles = [
  {
    id: 1,
    poste: "Administrateur Microsoft 365 / Développeur web & Intragration de solutions informatique",
    entreprise: "Système Intégrateur Connect (S.I CONNECT)",
    periode: "Février 2025 - Août 2025",
    lieu: "Dakar, Sénégal",
    type: "CDD",
    description:
      "Refonte de site web en intégrant le chatbot et la page d'accueil avec un slide dynamique, administration Microsoft 365",
    missions: [
      "Refonte du site web de l'entreprise avec intégration d'un chatbot pour permettre une communication fluide avec les clients pour les informations et services de l'entreprise",
      "Administration de produits Microsoft 365",
      "Microsoft Azure",
      "Gestion des appareils et accès sur Intune et Entra Microsoft 365",
      "Migration du système vers le Cloud (Microsoft Azure)",
      "Technico-commercial, en étant en contact avec les entreprises pour proposer les produits et services Microsoft",
    ],
    technologies: ["Microsoft 365", "No code", "Dolibarr", "HTML/CSS", "Azure Microsoft", "JavaScript"],
    realisations: [
      "Site web de l'entreprise",
      "Migration vers le cloud",
      "Administration et gestion d'accès des appareils",
    ],
  },
  {
    id: 2,
    poste: "Développeur web et Support IT",
    entreprise: "Digital Mind Plus Group",
    periode: "2024 - 2025",
    lieu: "Dakar, Sénégal",
    type: "CDD",
    description: "Développement des applications e-commerce, gestion de trésorerie, site web",
    missions: [
      "Gestion de projets TECH",
      "Gestion d’hébergemen",
      "Développement du site web de l'entreprise",
      "Développement de tunnel de vente de produits digitaux",
      "Développement du site web e-commerce de vente de fruits en ligne avec la réception de commandes des clients via WhatsApp Business",
      "Développement de l'application de gestion de trésorerie",
      "Analyse de données avec le tableau de bord en Power BI",
      "Administration et assistance technique du Groupe et de ses clients",
      "Maintenance et évolution des emails et hébergement de site client",
      "Gestion des emails du personnel",
    ],
    technologies: ["React js", "PHP", "JavaScript", "Laravel", "Sass", "HTML/CSS", "Power BI"],
    realisations: [
      "Développement de 2+ sites web clients",
      "Développement de 2 applications full stack",
      "Administration et gestion hébergement et email du groupe et de ses clients",
    ],
  },
  {
    id: 3,
    poste: "Support IT - Assistant administration réseau informatique",
    entreprise: "NAIRA GROUP",
    periode: "Octobre 2022 - Décembre 2023",
    lieu: "Saint-Louis, Sénégal",
    type: "Prestataire",
    description: "Assistant technique auprès des clients du groupe dans la région de Saint-Louis dans l'entreprise AGS",
    missions: [
      "Assistance technique et support informatique aux utilisateurs",
      "Installation, configuration et maintenance de postes et logiciels",
      "Supervision et Support IT",
      "Contribution à la gestion du réseau et à la sécurité informatique",
      "Suivi et documentation des incidents techniques",
      "Support client niveau 1 pour les problèmes techniques",
    ],
    technologies: [
      "VMware",
      "VirtualBox",
      "Hyper-V",
      "Protocoles réseaux : TCP/IP, DNS, DHCP, VPN ",
      "Outils de gestion des droits et sécurité : Active Directory (AD)",
    ],
    realisations: ["Gestion de parc informatique", "Assistance technique", "Maintenance postes et logiciels"],
  },
  {
    id: 4,
    poste: "Gestion de stock",
    entreprise: "Hôtel SINDONE",
    periode: "Juin 2021 - Octobre 2022",
    lieu: "Saint-Louis, Sénégal",
    type: "CDD",
    description: "Gestion de stock de produits d'entrées et sorties",
    missions: [
      "Support IT",
      "Gestion de produits de l'économat",
      "Gestion des achats",
      "Gestion des inventaires de matériels et produits quotidiens, mensuels et annuels",
      
    ],
    technologies: ["Orchestra PDV", "Orchestra Hébergement", "OpenConcerto", "Trello"],
    realisations: [
      "Supervision, maintenance de postes et logiciel",
      "Mise en fonction du logiciel Orchestra Point De Vente",
      "Mise en place d'un processus de gestion de stock de produits de cuisine, bar et linge de chambre",
      "Suivi régulier de stock de l'économat",
      "Gestion de réservation",
    ],
  },
  {
    id: 5,
    poste: "Tuteur informatique",
    entreprise: "Sénégal Academy",
    periode: "2020 - 2023",
    lieu: "Sénégal",
    type: "Temps partiel",
    description: "Tuteur de programmation au Lycée de Jeunes Filles Ameth Fall",
    missions: ["Dispenser des tutoriels en programmation", "Formation des jeunes filles aux outils technologiques"],
    technologies: ["HTML/CSS"],
    realisations: ["Application web HTML et CSS", "Développement d'application No code"],
  },
  {
    id: 6,
    poste: "Tuteur informatique",
    entreprise: "Mjangal",
    periode: "Avril 2020 - Juillet 2021",
    lieu: "En ligne - Sénégal",
    type: "Temps partiel",
    description: "Tuteur en programmation python en ligne pendant la période COVID19",
    missions: [
      " Tuteur en présentiel lors de Expresso Innovation tour de Saint-Louis",
      "Formation des jeunes en base de programmation",
    ],
    technologies: ["Python"],
    realisations: ["Développement des interfaces graphique", "Développement d'animation des jeux"],
  },
]

// Données des compétences techniques
const competencesTechniques = [
  {
    categorie: "Frontend",
    icon: Code,
    competences: [
      { nom: "React js", niveau: 80, couleur: "success" },
      { nom: "JavaScript/TypeScript", niveau: 60, couleur: "info" },
      { nom: "HTML5/CSS3", niveau: 95, couleur: "warning" },
      { nom: "Bootstrap/Sass", niveau: 85, couleur: "primary" },
    ],
  },
  {
    categorie: "Backend",
    icon: Server,
    competences: [
      { nom: "Node.js", niveau: 70, couleur: "success" },
      { nom: "Laravel", niveau: 85, couleur: "info" },
      { nom: "PHP", niveau: 80, couleur: "warning" },
      { nom: "Python", niveau: 75, couleur: "primary" },
      { nom: "Oracle", niveau: 75, couleur: "primary" },
      { nom: "PostgreSQL/MySQL", niveau: 80, couleur: "success" },
    ],
  },
  {
    categorie: "Technologies & Outils & DevOps",
    icon: Database,
    competences: [
      { nom: "Administration Microsoft 365", niveau: 90, couleur: "success" },
      { nom: "Git/GitHub", niveau: 90, couleur: "dark" },
      { nom: "Pipeline CI/CD GitHub Actions", niveau: 90, couleur: "dark" },
      { nom: "Postman", niveau: 70, couleur: "warning" },
    ],
  },
]

// Données des projets
const projetsRealises = [
  {
    id: 1,
    titre: "Plateforme E-commerce de vente de fruits",
    client: "Digital Mind Plus Group",
    description:
      "Développement d'une plateforme e-commerce pour la vente de divers fruits avec la réception de commandes des clients via WhatsApp Business.",
    technologies: ["React", "Node.js", "PostgreSQL"],
    duree: "1 mois | Janvier 2024",
    equipe: "2 développeurs",
    fonctionnalites: [
      "Catalogue produits avec une sélection",
      "Ajout de produits au panier",
      "Confirmation de commande avec les informations du client qui sont ensuite réceptionnées par le chargé de traitement de commande via WhatsApp",
      "Alerte de réception de commande",
      "Intégration paiements sécurisés (Module non déployé)",
    ],
    resultats: "Ventes en ligne avec la réception de la commande à la minute près",
    github: "https://github.com/giressekifouani/Fraicheur-teranga_Projet",
    demo: "https://www.youtube.com/@codingnumeric7177",
  },
  {
    id: 2,
    titre: "Site Vitrine Digital Mind Plus Group",
    client: "Digital Mind Plus Group",
    description: "Site vitrine moderne et responsive pour la mise en avant des services proposés par le groupe",
    technologies: ["React js", "Hébergement LWS"],
    duree: "1 mois",
    equipe: "1 développeur | Février 2024",
    fonctionnalites: ["Design responsive et animations fluides"],
    resultats: "Visibilité des services du groupe",
    github: "https://github.com/giressekifouani/site-web-DMplus-Group",
    demo: "https://www.youtube.com/@codingnumeric7177",
  },
  {
    id: 3,
    titre: "Application mobile de gestion de service d'urgence du Centre Hospitalier Régional de Saint-Louis, Sénégal",
    client: "Projet SIMENS URGENCE",
    description: "Application mobile en extension de l'application web existante. Projet de stage de fin d'études.",
    technologies: ["React Native", "PHP", "MySQL", "PhpMyAdmin", "Postman"],
    duree: "4 mois | Août 2023 - Décembre 2023",
    equipe: "équipe de SIMENS URGENCE | Projet PYRAMIDIS",
    fonctionnalites: [
      "Interface de connexion de différents profils",
      "Enregistrement et tri des patients",
      "Hospitalisation",
      "Dossier médical",
      "Facturation",
    ],
    resultats: "Application mobile en extension de l'application web existante",
    github: "https://github.com/giressekifouani",
    demo: "https://www.youtube.com/@codingnumeric7177",
  },
  {
    id: 4,
    titre: "Plateforme de gestion de flux de trésorerie",
    client: "Digital Mind Plus Group",
    description: "Plateforme de gestion et suivi des flux financiers pour optimiser la trésorerie de l'entreprise",
    technologies: ["React js", "PHP", "HTML/CSS/JavaScript", "Hébergement LWS"],
    duree: "6 mois | Mars 2024 - Septembre 2024",
    equipe: "2 développeurs | Digital Mind Plus Group",
    fonctionnalites: ["Design responsive et animations fluides"],
    resultats: "Visibilité des services du groupe",
    github: "https://github.com/giressekifouani/APPRENTISSAGE-SUPERVISE-PROJET-FLUX-DE-TRESORERIE",
    demo: "https://www.youtube.com/@codingnumeric7177",
  },
  {
    id: 5,
    titre: "Tunnel de vente de produit digitaux",
    client: "Digital Mind Plus Group",
    description: "Développement d'une application web de vente en ligne de produits digitaux",
    technologies: ["React.Js", "Hébergement LWS"],
    duree: "3 semaines | Décembre 2024",
    équipe: "2 développeurs | Digital Mind Plus Group ",
    fonctionnalites: ["Ajout au panier de produit, paiement en ligne"],
    resultats:
      "L'utilisateur sélectionne le produits a achter en ligne via le tunnel, ensuite il procede au paiement en ligne avec la plateforme chariow ",
    github: "",
    demo: "https:/academy.dmplus-group.com",
  },
  {
    id: 6,
    titre: "API RESTful avec Laravel",
    client: "Digital Mind Plus Group",
    description: "Développement d'une API RESTful avec Laravel, création d'une pipelene CI/CD GitHub Actions",
    technologies: ["Laravel", "PostgreSQL", "Postman", "Hébergement LWS"],
    duree: "3 semaines",
    équipe: "1 développeur | Digital Mind Plus Group ",
    fonctionnalites: ["CI/CD Actions GitHub"],
    resultats: "Une API dédiée à la gestion des services, disponible et prête à l'utilisation côté backend. ",
    github: "https://github.com/giressekifouani/api-rest-laravel3",
    demo: "https://www.youtube.com/@codingnumeric7177",
  },

   {
    id: 7,
    titre: "API de gestion de services administratifs consulaire",
    client: "Projet personnel",
    description: "Développement d'une API RESTful avec Laravel pour une application mobile de gestion consulaire",
    technologies: ["Laravel", "PostgreSQL", "Postman"],
    duree: "En cours de développement",
    équipe: "1 développeur ",
    fonctionnalites: ["Gestion des citoyens enregistrés", "Service administratifs", "Suivi du dossier", "Prise de rendez-vous", "Authentification et sécurité"],
    resultats: "Une API dédiée à la gestion des services administratifs consulaire. ",
    github: "https://github.com/giressekifouani/API-REST-MyConsulatCG-APPLI",
    demo: "",
  },
  {
    id: 8,
    titre: "Application Mobile pour la gestion de services administratifs consulaire",
    client: "Projet personnel",
    description: "Développement d'une application mobile pour gestion des services administratifs consulaire",
    technologies: ["React Native", "Laravel", "PostgreSQL", "Postman"],
    duree: "En cours de développement",
    équipe: "1 développeur ",
    fonctionnalites: ["Gestion des citoyens enregistrés", "Service administratifs", "Suivi du dossier", "Prise de rendez-vous", "Authentification et sécurité"],
    resultats: "Une API dédiée à la gestion des services administratifs consulaire. ",
    github: "https://github.com/giressekifouani/API-REST-MyConsulatCG-APPLI",
    demo: "",
  },
]

const useIntersectionObserver = (options = {}) => {
  const [isIntersecting, setIsIntersecting] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting)
      },
      { threshold: 0.1, ...options },
    )

    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => observer.disconnect()
  }, [])

  return [ref, isIntersecting]
}

const FadeInSection = ({ children, className = "", delay = 0 }) => {
  const [ref, isIntersecting] = useIntersectionObserver()

  return (
    <div
      ref={ref}
      className={`transition-all duration-1000 ${
        isIntersecting ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
      } ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  )
}

const AnimatedIcon = ({ Icon, className = "", size = 24, delay = 0 }) => {
  const [ref, isIntersecting] = useIntersectionObserver()

  return (
    <div
      ref={ref}
      className={`inline-block transition-all duration-700 ${
        isIntersecting ? "opacity-100 scale-100 rotate-0" : "opacity-0 scale-50 -rotate-45"
      } ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <Icon size={size} className="animate-pulse" />
    </div>
  )
}

export const Accueil = () => {
  const particlesInit = async (main) => {
    await loadFull(main)
  }

  const [activeLink, setActiveLink] = useState("accueil")
  const [scrolled, setScrolled] = useState(false)
  const sectionsRef = useRef({})

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY >= 50)
      const scrollY = window.scrollY + window.innerHeight / 2
      Object.entries(sectionsRef.current).forEach(([key, ref]) => {
        if (ref && ref.offsetTop <= scrollY && ref.offsetTop + ref.offsetHeight > scrollY) {
          setActiveLink(key)
        }
      })
    }
    window.addEventListener("scroll", onScroll)
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value)
    const el = document.getElementById(value)
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show")
          }
        })
      },
      { threshold: 0.2 },
    )

    document.querySelectorAll(".content-section").forEach((section) => observer.observe(section))
    return () => observer.disconnect()
  }, [])

  return (
    <>
      <style>{`
        .content-section {
          opacity: 1 !important;
          transform: translateY(0) !important;
          transition: opacity 0.8s ease-out, transform 0.8s ease-out;
        }

        .content-section.show {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }

        .hover-lift {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .hover-lift:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
        }

        .timeline-card {
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
          padding: 2rem;
          margin-bottom: 1.5rem;
          position: relative;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          min-height: 300px;
        }

        .timeline-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
        }

        .card-hover {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          cursor: pointer;
        }

        .card-hover:hover {
          transform: scale(1.02);
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
        }

        .tech-badge {
          font-size: 0.85rem;
          padding: 0.4rem 0.8rem;
          margin: 0.2rem;
          display: inline-block;
        }

        .project-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .project-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2) !important;
        }

        #experience {
          background-color: #f8f9fa;
          min-height: 100vh;
          padding: 100px 0 50px;
        }

        @media (max-width: 768px) {
          .timeline-card {
            padding: 1.5rem;
            min-height: auto;
          }
        }
      `}</style>

      <section className="accueil" id="accueil">
        <Particles id="particles" init={particlesInit} options={particleOptions} />

        <Navbar expand="lg" fixed="top" className={scrolled ? "scrolled" : ""}>
          <Container>
            <Navbar.Brand
              href="#accueil"
              className={activeLink === "accueil" ? "active navbar-link" : "navbar-link"}
              onClick={() => onUpdateActiveLink("accueil")}
            >
              <img
                src={require("../assets/images/Gires.png")}
                alt="Logo"
                style={{
                  height: "80px",
                  width: "80px",
                  borderRadius: "60%",
                  objectFit: "cover",
                }}
              />
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                {["apropos", "competences", "experience", "projets", "contact"].map((id) => (
                  <Nav.Link
                    key={id}
                    href={`#${id}`}
                    className={activeLink === id ? "active navbar-link" : "navbar-link"}
                    onClick={() => onUpdateActiveLink(id)}
                  >
                    {id === "apropos"
                      ? "À propos"
                      : id === "competences"
                        ? "Compétences"
                        : id === "experience"
                          ? "Expériences"
                          : id === "projets"
                            ? "Projets"
                            : "Contact"}
                  </Nav.Link>
                ))}
                <Nav.Link
                  as={Link}
                  to="/blog"
                  className={activeLink === "blog" ? "active navbar-link" : "navbar-link"}
                  onClick={() => onUpdateActiveLink("blog")}
                >
                  Blog
                </Nav.Link>
              </Nav>
              <div className="social-media">
                <a
                  href="https://www.linkedin.com/in/giresse-m-kifouani-94369b1a3/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="me-3 text-white"
                >
                  <Linkedin size={20} className="hover:scale-110 transition-transform" />
                </a>
                <a
                  href="https://github.com/giressekifouani"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="me-3 text-white"
                >
                  <Github size={20} className="hover:scale-110 transition-transform" />
                </a>
                <a
                  href="https://www.facebook.com/people/Coding-numeric/100065556127221/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="me-3 text-white"
                >
                  <i className="bi bi-facebook fs-5"></i>
                </a>
                <a
                  href="https://www.instagram.com/coding_numeric/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="me-3 text-white"
                >
                  <i className="bi bi-instagram fs-5"></i>
                </a>
              </div>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <section
          className="intro-section d-flex align-items-center"
          style={{ minHeight: "100vh", paddingTop: "80px" }}
          ref={(el) => (sectionsRef.current["accueil"] = el)}
        >
          <Container>
            <Row className="align-items-center">
              <Col md={6} className="text-center text-md-start mb-4 mb-md-0">
                <FadeInSection delay={100}>
                  <div className="d-flex align-items-center mb-3">
                    <AnimatedIcon Icon={Zap} size={32} className="me-2 text-warning" delay={200} />
                    <h2 className="mb-0">Bonjour, je suis</h2>
                  </div>
                  <h1 className="display-4 fw-bold mb-3">Giresse M. KIFOUANI</h1>
                </FadeInSection>
                <FadeInSection delay={300}>
                  <p className="lead mb-4">
                    <AnimatedIcon Icon={Code} size={20} className="me-2 text-primary" delay={400} />
                    Informaticien professionnel spécialisé dans le développement d'applications full stack performantes et innovantes, administrateur de bases de données relationnelles et non relationnelles, et support IT.
                  </p>
                </FadeInSection>
                <FadeInSection delay={500}>
                  <div className="mt-4">
                    <a href="#projets" className="btn btn-primary me-3">
                      <Rocket size={18} className="me-2" />
                      Voir mes projets
                    </a>
                    <a
                      href="https://wa.me/221776530197?text=Bonjour%20Giresse,%20j'aimerais%20recevoir%20votre%20CV."
                      className="btn btn-outline-light"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <ExternalLink size={18} className="me-2" />
                      Télécharger mon CV
                    </a>
                  </div>
                </FadeInSection>
              </Col>
              <Col md={6} className="text-center">
                <FadeInSection delay={600}>
                  <div className="position-relative d-inline-block">
                    <img
                      src={require("../assets/images/gk.jpeg") || "/placeholder.svg"}
                      alt="Profil développeur"
                      className="img-fluid rounded-circle shadow-lg"
                      style={{ maxWidth: "300px", border: "5px solid #007bff" }}
                    />
                    <div className="position-absolute" style={{ top: "-10px", right: "-10px" }}>
                      <AnimatedIcon Icon={Award} size={40} className="text-warning" delay={800} />
                    </div>
                  </div>
                </FadeInSection>
              </Col>
            </Row>
          </Container>
        </section>

        <section
          id="apropos"
          ref={(el) => (sectionsRef.current["apropos"] = el)}
          className="content-section fade-in py-5"
        >
          <Container>
            <FadeInSection>
              <h2 className="text-center mb-5">
                <AnimatedIcon Icon={User} size={32} className="me-3 text-primary" />
                Mon Parcours
              </h2>
            </FadeInSection>

            <FadeInSection delay={200}>
              <Card className="h-100 border-0 shadow-lg p-4 mb-4">
                <p className="lead">
                  Développeur full stack avec plus de 4 ans d'expérience, dans la création des applications web modernes
                  et performantes avec les dernières technologies. Mon approche combine la gestion de projet et
                  expertise technique pour livrer des solutions de pointe.
                </p>
                <p>
                  Toujours à la veille technologiques, j'aime travailler sur les projets complexes et collaborer avec
                  des équipes multidisciplinaires pour créer des produits innovants.
                </p>
                <p>
                  Diplômé en Génie Informatique à l'université Gaston Berger de Saint-Louis, Sénégal après un parcours
                  en Mathématiques Appliquées et Sciences Sociales (MASS), j'ai acquis une solide expertise en
                  Mathématiques et en Informatique.
                </p>

                <Row className="text-center mt-4">
                  <Col md={6} className="mb-3">
                    <FadeInSection delay={400}>
                      <AnimatedIcon Icon={Target} size={40} className="text-success mb-2" delay={500} />
                      <h3 className="fw-bold">10+</h3>
                      <p className="text-muted">Projets réalisés 🚀</p>
                    </FadeInSection>
                  </Col>
                  <Col md={6} className="mb-3">
                    <FadeInSection delay={600}>
                      <AnimatedIcon Icon={TrendingUp} size={40} className="text-info mb-2" delay={700} />
                      <h3 className="fw-bold">3+</h3>
                      <p className="text-muted">Années d'expérience</p>
                    </FadeInSection>
                  </Col>
                </Row>
              </Card>
            </FadeInSection>

            <FadeInSection delay={800}>
              <Card className="h-100 border-0 shadow-lg p-4">
                <h2 className="text-center mb-4 text-dark">
                  <AnimatedIcon Icon={Database} size={32} className="me-3 text-primary" delay={900} />
                  Stack Technique Principale
                </h2>
                <Row>
                  <Col md={6}>
                    <FadeInSection delay={1000}>
                      <div className="mb-4">
                        <h5 className="d-flex align-items-center">
                          <AnimatedIcon Icon={Server} size={20} className="me-2 text-success" delay={1100} />
                          Back-end
                        </h5>
                        <p>Laravel (PHP), Spring Boot (Java), création d'API RESTful robustes et sécurisées</p>
                      </div>
                    </FadeInSection>
                    <FadeInSection delay={1200}>
                      <div className="mb-4">
                        <h5 className="d-flex align-items-center">
                          <AnimatedIcon Icon={Palette} size={20} className="me-2 text-warning" delay={1300} />
                          Front-end
                        </h5>
                        <p>React.js, React Native</p>
                      </div>
                    </FadeInSection>
                    <FadeInSection delay={1400}>
                      <div className="mb-4">
                        <h5 className="d-flex align-items-center">
                          <AnimatedIcon Icon={Database} size={20} className="me-2 text-info" delay={1500} />
                          Bases de données
                        </h5>
                        <p>PostgreSQL, Oracle, MySQL Workbench, MongoDB</p>
                      </div>
                    </FadeInSection>
                  </Col>
                  <Col md={6}>
                    <FadeInSection delay={1600}>
                      <div className="mb-4">
                        <h5 className="d-flex align-items-center">
                          <AnimatedIcon Icon={Code} size={20} className="me-2 text-primary" delay={1700} />
                          Langages
                        </h5>
                        <p>PHP, Python, Java, JavaScript</p>
                      </div>
                    </FadeInSection>
                    <FadeInSection delay={1800}>
                      <div className="mb-4">
                        <h5 className="d-flex align-items-center">
                          <AnimatedIcon Icon={Globe} size={20} className="me-2 text-success" delay={1900} />
                          DevOps & CI/CD
                        </h5>
                        <p>GitHub Actions, automatisation des pipelines de déploiement</p>
                      </div>
                    </FadeInSection>
                    <FadeInSection delay={2000}>
                      <div className="mb-4">
                        <h5 className="d-flex align-items-center">
                          <AnimatedIcon Icon={Cloud} size={20} className="me-2 text-info" delay={2100} />
                          Microsoft Azure
                        </h5>
                        <p>Déploiement et gestion des applications sur le cloud Azure, services PaaS et IaaS</p>
                      </div>
                    </FadeInSection>
                    <FadeInSection delay={2200}>
                      <div className="mb-4">
                        <h5 className="d-flex align-items-center">
                          <AnimatedIcon Icon={TrendingUp} size={20} className="me-2 text-warning" delay={2300} />
                          Analyse de données
                        </h5>
                        <p>Power BI pour la visualisation et l'aide à la décision</p>
                      </div>
                    </FadeInSection>
                  </Col>
                </Row>
              </Card>
            </FadeInSection>
          </Container>
        </section>

        <section
          id="competences"
          ref={(el) => (sectionsRef.current["competences"] = el)}
          className="content-section fade-in py-5"
        >
          <Container>
            <FadeInSection>
              <h2 className="text-center mb-5">
                <AnimatedIcon Icon={Zap} size={32} className="me-3 text-warning" />
                Mes Compétences
              </h2>
            </FadeInSection>
            <Row>
              {competencesTechniques.map((categorie, index) => (
                <Col lg={4} key={index} className="mb-4">
                  <FadeInSection delay={index * 200}>
                    <Card className="h-100 border-0 shadow-lg hover-lift">
                      <Card.Body>
                        <h4 className="text-center mb-4 text-primary d-flex align-items-center justify-content-center">
                          <AnimatedIcon Icon={categorie.icon} size={28} className="me-2" delay={index * 200 + 100} />
                          {categorie.categorie}
                        </h4>
                        {categorie.competences.map((comp, idx) => (
                          <FadeInSection key={idx} delay={index * 200 + idx * 100}>
                            <div className="mb-3">
                              <div className="d-flex justify-content-between mb-1">
                                <span className="fw-semibold">{comp.nom}</span>
                                <span className="text-muted">{comp.niveau}%</span>
                              </div>
                              <ProgressBar
                                variant={comp.couleur}
                                now={comp.niveau}
                                className="mb-2"
                                style={{ height: "10px" }}
                              />
                            </div>
                          </FadeInSection>
                        ))}
                      </Card.Body>
                    </Card>
                  </FadeInSection>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section
          id="experience"
          ref={(el) => (sectionsRef.current["experience"] = el)}
          className="content-section py-5"
          style={{ backgroundColor: "#f8f9fa" }}
        >
          <Container>
            <FadeInSection>
              <h2 className="text-center mb-5 text-primary">
                <AnimatedIcon Icon={Briefcase} size={32} className="me-3 text-primary" />
                Expériences Professionnelles
              </h2>
            </FadeInSection>

            <Row className="g-4">
              {experiencesProfessionnelles.map((exp, index) => (
                <Col key={exp.id} lg={6} md={12}>
                  <FadeInSection delay={index * 200}>
                    <div className="timeline-card card-hover">
                      <div className="text-center mb-3">
                        <AnimatedIcon
                          Icon={Award}
                          size={24}
                          className="text-primary"
                          delay={index * 200 + 100}
                        />
                      </div>
                      <h3 className="text-primary mb-2 text-center">{exp.poste}</h3>
                      <h5 className="text-muted mb-3 text-center">{exp.entreprise}</h5>
                      <div className="text-center mb-3">
                        <Badge bg="primary" className="mb-2">
                          <Calendar size={14} className="me-1" />
                          {exp.periode}
                        </Badge>
                        <div className="small text-muted mt-2">
                          <MapPin size={14} className="me-1" />
                          {exp.lieu} • {exp.type}
                        </div>
                      </div>

                      <p className="text-dark mb-3 text-center">{exp.description}</p>

                      <h5 className="text-primary mb-2 d-flex align-items-center justify-content-center">
                        <AnimatedIcon
                          Icon={Target}
                          size={20}
                          className="me-2"
                          delay={index * 200 + 200}
                        />
                        Missions principales :
                      </h5>
                      <ul className="text-dark mb-3 text-start">
                        {exp.missions.map((mission, missionIdx) => (
                          <li key={missionIdx} className="mb-2">
                            {mission}
                          </li>
                        ))}
                      </ul>

                      <h6 className="text-primary mb-2 d-flex align-items-center justify-content-center">
                        <AnimatedIcon
                          Icon={Code}
                          size={20}
                          className="me-2"
                          delay={index * 200 + 300}
                        />
                        Technologies :
                      </h6>
                      <div className="d-flex flex-wrap gap-2 justify-content-center">
                        {exp.technologies.map((tech, techIdx) => (
                          <Badge key={techIdx} bg="secondary" className="tech-badge">
                            {tech}
                          </Badge>
                        ))}
                      </div>
                    </div>
                  </FadeInSection>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section
          id="projets"
          ref={(el) => (sectionsRef.current["projets"] = el)}
          className="content-section fade-in py-5"
        >
          <Container>
            <FadeInSection>
              <h2 className="text-center mb-5">
                <AnimatedIcon Icon={Rocket} size={32} className="me-3 text-danger" />
                Mes Projets (projets phares)
              </h2>
            </FadeInSection>
            <Row>
              {projetsRealises.map((projet, index) => (
                <Col lg={4} md={6} key={projet.id} className="mb-4">
                  <FadeInSection delay={index * 150}>
                    <Card className="project-card h-100 border-0 shadow-lg hover-lift">
                      <Card.Header className="bg-primary text-white">
                        <h5 className="text-center mb-0 text-white d-flex align-items-center justify-content-center">
                          <AnimatedIcon Icon={Globe} size={20} className="me-2 text-white" delay={index * 150 + 100} />
                          {projet.titre}
                        </h5>
                      </Card.Header>
                      <Card.Body>
                        <p className="text-muted mb-3">{projet.description}</p>

                        <div className="mb-3 small">
                          <strong>
                            <Calendar size={16} className="me-1" />
                            Durée:
                          </strong>{" "}
                          {projet.duree} |
                          <strong className="ms-2">
                            <User size={16} className="me-1" />
                            Équipe:
                          </strong>{" "}
                          {projet.equipe}
                        </div>

                        <h6 className="text-primary mb-2 d-flex align-items-center">
                          <Zap size={18} className="me-2" />
                          Fonctionnalités clés :
                        </h6>
                        <ul className="small mb-3">
                          {projet.fonctionnalites.map((fonc, idx) => (
                            <li key={idx} className="mb-1">
                              {fonc}
                            </li>
                          ))}
                        </ul>

                        <div className="mb-3 d-flex flex-wrap gap-1">
                          {projet.technologies.map((tech, idx) => (
                            <Badge key={idx} bg="secondary" className="mb-1">
                              {tech}
                            </Badge>
                          ))}
                        </div>

                        <div className="d-flex justify-content-center gap-2 mt-3">
                          {projet.github && (
                            <a
                              href={projet.github}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-outline-dark d-flex align-items-center"
                              title="Code source sur GitHub"
                            >
                              <Github size={16} className="me-1" /> GitHub
                            </a>
                          )}
                          {projet.demo && (
                            <a
                              href={projet.demo}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-outline-danger d-flex align-items-center"
                              title="Voir la démo vidéo"
                            >
                              <ExternalLink size={16} className="me-1" /> Démo
                            </a>
                          )}
                        </div>
                      </Card.Body>
                    </Card>
                  </FadeInSection>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section
          id="contact"
          ref={(el) => (sectionsRef.current["contact"] = el)}
          className="content-section fade-in py-5"
        >
          <Container>
            <FadeInSection>
              <h2 className="text-center mb-5">
                <AnimatedIcon Icon={MessageSquare} size={32} className="me-3 text-info" />
                Contact
              </h2>
            </FadeInSection>
            <Row>
              <Col lg={6} className="mb-4">
                <FadeInSection delay={200}>
                  <Card className="border-0 shadow-lg h-100">
                    <Card.Body className="p-4">
                      <h4 className="mb-4 d-flex align-items-center">
                        <AnimatedIcon Icon={Phone} size={24} className="me-2 text-primary" delay={300} />
                        Me joindre
                      </h4>
                      <p className="mb-4">
                        Je suis toujours ouvert à de nouveaux défis et opportunités. N'hésitez pas à me contacter pour
                        toute offre ou pour discuter de votre projet
                      </p>
                      <div className="mb-3 d-flex align-items-start">
                        <Mail size={20} className="me-2 text-primary mt-1" />
                        <div>
                          <strong>Email:</strong>
                          <br />
                          mpassi.mignon-giresse@ugb.edu.sn
                          <br />
                          giressekifouani@dmplus-group.com
                          <br />
                          giressekifouani@sicsn.com
                        </div>
                      </div>
                      <div className="mb-3 d-flex align-items-center">
                        <Phone size={20} className="me-2 text-success" />
                        <div>
                          <strong>Téléphone:</strong> +221 77 653 01 97
                        </div>
                      </div>
                      <div className="mb-3 d-flex align-items-center">
                        <MapPin size={20} className="me-2 text-danger" />
                        <div>
                          <strong>Localisation:</strong> Dakar, Sénégal
                        </div>
                      </div>
                      <div className="mb-3 d-flex align-items-center">
                        <Linkedin size={20} className="me-2 text-info" />
                        <div>
                          <strong>LinkedIn:</strong> linkedin.com/in/giresse-m-kifouani
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </FadeInSection>
              </Col>
              <Col lg={6}>
                <FadeInSection delay={400}>
                  <Card className="border-0 shadow-lg">
                    <Card.Body className="p-4">
                      <h5 className="mb-4 d-flex align-items-center">
                        <AnimatedIcon Icon={Send} size={24} className="me-2 text-primary" delay={500} />
                        Envoyez-moi un message
                      </h5>
                      <Row>
                        <Col md={6} className="mb-3">
                          <input type="text" className="form-control" placeholder="Votre nom" />
                        </Col>
                        <Col md={6} className="mb-3">
                          <input type="email" className="form-control" placeholder="Votre email" />
                        </Col>
                      </Row>
                      <div className="mb-3">
                        <input type="text" className="form-control" placeholder="Sujet du message" />
                      </div>
                      <div className="mb-3">
                        <textarea className="form-control" rows="5" placeholder="Votre message..."></textarea>
                      </div>
                      <button
                        className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                        onClick={() => alert("Veuillez me contacter via le mail")}
                      >
                        <Send size={18} className="me-2" />
                        Envoyer le message
                      </button>
                    </Card.Body>
                  </Card>
                </FadeInSection>
              </Col>
            </Row>
          </Container>
        </section>
      </section>
    </>
  )
}